module.exports = __webpack_public_path__ + "img/Rectangle353.80c8b897.png";